import BorderBox2 from './main'
export default function (Vue) {
  Vue.component(BorderBox2.name, BorderBox2)
}



// WEBPACK FOOTER //
// ./src/components/border/border-box-2/index.js